<template>
  <el-popover
    placement="top-start"
    title=""
    width="280"
    trigger="hover"
    class="teu-popover">
    <div class="table-header-popover-custom-content">
      <p>Shipment weights are automatically corrected for unit errors and outliers, based on container type and TEU.</p>
    </div>
    <i 
      slot="reference" 
      class="el-icon-info"/>
  </el-popover>
</template>
    
<script>
export default {
  name: 'GrossWeightPopover'
}
</script>
  
<style scoped>
.table-header-popover-custom-content {
  max-height: 200px !important;
  overflow: auto;
}

.el-popover {
  .table-header-popover-custom-content {
    p {
      margin-bottom: 16px;
      line-height: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }
    ul {
      padding-top: 0;
      padding-bottom: 0;
      margin-left: 16px;
      list-style: disc;
      li {
        padding-top: 0;
        padding-left: 0;

        &:hover {
          color: #344050;
          cursor: unset;
          background: none;
        }

        &:last-child {
          padding-bottom: 16px;
        }
      }
    }
  }
}
</style>
